export const GET_CURRENT_USER_DETAILS = "GET_CURRENT_USER_DETAILS";
export const GET_CURRENT_USER_DETAILS_INIT = "GET_CURRENT_USER_DETAILS_INIT";
export const GET_CURRENT_USER_DETAILS_SUCCESS =
  "GET_CURRENT_USER_DETAILS_SUCCESS";
export const GET_CURRENT_USER_DETAILS_FAILED =
  "GET_CURRENT_USER_DETAILS_FAILED";

export const UPDATE_USER_PROFILE = "UPDATE@UPDATE_USER_PROFILE";
export const UPDATE_USER_PROFILE_INIT = "UPDATE@UPDATE_USER_PROFILE_INIT";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE@UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAILED = "UPDATE@UPDATE_USER_PROFILE_FAILED";

export const UPDATE_USER_PASSWORD = "UPDATE@UPDATE_USER_PASSWORD";
export const UPDATE_USER_PASSWORD_INIT = "UPDATE@UPDATE_USER_PASSWORD_INIT";
export const UPDATE_USER_PASSWORD_SUCCESS =
  "UPDATE@UPDATE_USER_PASSWORD_SUCCESS";
export const UPDATE_USER_PASSWORD_FAILED = "UPDATE@UPDATE_USER_PASSWORD_FAILED";
